import { Route, Routes } from 'react-router';
import { Layout } from './components/Layout';
import { AboutPage } from './pages/AboutPage';
import { AccountPage } from './pages/AccountPage';
import { ChangelogPage } from './pages/ChangelogPage';
import { HomePage } from './pages/HomePage';
import { LegalPage } from './pages/LegalPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PluginsPage } from './pages/PluginsPage';
import { ProductPage } from './pages/ProductPage';
import { SupportPage } from './pages/SupportPage';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="plugins" element={<PluginsPage />} />
        <Route path="plugins/:slug" element={<ProductPage />} />
        <Route path="support" element={<SupportPage />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="changelog" element={<ChangelogPage />} />
        <Route path="legal/:document" element={<LegalPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
